import { create } from "zustand";
import { getAllWorkers } from "../services/Workers";

const useWorkerStore = create((set, get) => ({
  apiLoading: false,
  allWorkers: [],
  pageLimit: 10,
  currentPage: 0,
  totalRecords: 0,
  searchQuery: "",
  dataLoaded: false,
  isInitialized: false,

  fetchWorkers: async (search = "") => {
    set({ apiLoading: true, searchQuery: search });
    try {
      const response = await getAllWorkers(search);
      const workersRes = response?.data;

      if (workersRes?.status === "success") {
        set({
          allWorkers: workersRes.data.workers || [],
          totalRecords: workersRes.data.workers?.length || 0,
          apiLoading: false,
          dataLoaded: true,
          isInitialized: true,
        });
      } else {
        set({ apiLoading: false });
        console.error("Failed to load workers:", workersRes?.message);
      }
    } catch (error) {
      set({ apiLoading: false });
      console.error("Error loading workers:", error);
    }
  },

  initializeData: async () => {
    const { dataLoaded, apiLoading, isInitialized, fetchWorkers } = get();
    if (!dataLoaded && !apiLoading && !isInitialized) {
      await fetchWorkers("");
    }
  },

  setAllWorkers: (data) =>
    set({ allWorkers: data, totalRecords: data?.length || 0, apiLoading: false, dataLoaded: true }),
  setLoading: (value) => set({ apiLoading: value }),
  setPageLimit: (value) => set({ pageLimit: value }),
  setCurrentPage: (value) => set({ currentPage: value }),
  setTotalRecords: (value) => set({ totalRecords: value }),
  setDataLoaded: (value) => set({ dataLoaded: value }),
  setSearchQuery: (value) => set({ searchQuery: value }),
  resetWorkerData: () =>
    set({
      allWorkers: [],
      totalRecords: 0,
      currentPage: 0,
      searchQuery: "",
      dataLoaded: false,
      apiLoading: false,
      isInitialized: false,
    }),
  refreshWorkerData: async () => {
    const { searchQuery, fetchWorkers } = get();
    await fetchWorkers(searchQuery || "");
  },
}));

export default useWorkerStore;
